// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { Button, Table } from "antd";
// import {
//   Avatar_06,
//   Avatar_07,
//   Avatar_14,
//   Avatar_18,
//   Avatar_19,
//   Avatar_22,
//   Avatar_26,
//   Avatar_29,
// } from "../../../Routes/ImagePath";
// import DeleteModal from "../../../components/modelpopup/DeleteModal";
// import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
// import SearchBox from "../../../components/SearchBox";
// import Breadcrumbs from "../../../components/Breadcrumbs";
// import ClientsFilter from "../../../components/ClientsFilter";
// import { DeskModal } from "./DeskModal";
// import DeskFilter from "./DeskFilter";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";
// import { render } from "@testing-library/react";
// import DeskWorkDeleteModal from "../../../components/modelpopup/DeskWorkDeleteModal";
// import moment from "moment";

// const DeskList = () => {
//   const [allData,setAllData] = useState([])

//   const allDeskData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id;
//       const response = await axios.get(`${Api_Url}api/v1/DeskWork?UserId=${id}&PageNumber=1&PageSize=10`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user'))?.accessToken}`,
//         }
//       })
//       console.log("response", response.data);
//       setAllData(response?.data?.data)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     allDeskData()
//   }, [])

//   const [deleteId,setDeleteId] = useState(null)
//   const DeskWorkDeleteFunction=async () => {
//     try {
//       const response = await axios.delete(`${Api_Url}api/v1/DeskWork/${deleteId}`,{
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       allDeskData()
//     } catch (error) {
//       return error.message
//     }
//   }

//   const [selectedId,setSelectedId] = useState(null)

//   // console.log("object",selectedId)

//   // console.log("object",allData)
//   const columns = [
//     // {
//     //   title: "Name",
//     //   dataIndex: "Name",
//     //   render: (text, record) => (
//     //     <span className="table-avatar">
//     //       <Link to="/profile" className="avatar">
//     //         <img alt="" src={record.Image} />
//     //       </Link>
//     //       <Link to="/profile">{text}</Link>
//     //     </span>
//     //   ),
//     //   sorter: (a, b) => a.Name.length - b.Name.length,
//     // },
//     {
//       title: "Branch Name",
//       dataIndex: "branchName",
//     },
//     {
//       title: "Application No.",
//       dataIndex: "applicationNo"
//     },
//     {
//       title: "Loan Number",
//       dataIndex: "loanNumber",
//     },
//     {
//       title: "Remark",
//       dataIndex: "remark",
//     },
//     {
//       title: "Last Activity",
//       dataIndex: "",
//       render: (text, record) => (
//         <span className="table-avatar">
//           {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
//         </span>
//       ),
//     },
//     {
//       title: "Location",
//       dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//       render: (text, record) => (
//         <a
//           href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//           target="_blank"
//           rel="noopener noreferrer"
//         >
//           <i class="fa-solid fa-location-dot"></i>
//         </a>
//       )},
//     // {
//     //   title: "Mobile",
//     //   dataIndex: "Mobile",
//     //   sorter: (a, b) => a.Mobile.length - b.Mobile.length,
//     // },
//     // {
//     //   title: "Status",
//     //   dataIndex: "Status",
//     //   render: (text) => (
//     //     <div className="dropdown">
//     //       <Link
//     //         to="#"
//     //         className="btn btn-white btn-sm btn-rounded dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i
//     //           className={
//     //             text === "Active"
//     //               ? "far fa-dot-circle text-success"
//     //               : "far fa-dot-circle text-danger"
//     //           }
//     //         />{" "}
//     //         {text}{" "}
//     //       </Link>
//     //       <div className="dropdown-menu">
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-success" /> Active
//     //         </Link>
//     //         <Link className="dropdown-item" to="#">
//     //           <i className="far fa-dot-circle text-danger" /> Inactive
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: (a, b) => a.Status.length - b.Status.length,
//     // },

//     // {
//     //   title: "Action",
//     //   render: (item) => (
//     //     <div className="dropdown dropdown-action text-end">
//     //       <Link
//     //         to="#"
//     //         className="action-icon dropdown-toggle"
//     //         data-bs-toggle="dropdown"
//     //         aria-expanded="false"
//     //       >
//     //         <i className="material-icons">more_vert</i>
//     //       </Link>
//     //       <div className="dropdown-menu dropdown-menu-right">
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#edit_client"
//     //           onClick={()=>setSelectedId(item.id)}
//     //         >
//     //           <i className="fa fa-pencil m-r-5" /> Edit
//     //         </Link>
//     //         <Link
//     //           className="dropdown-item"
//     //           to="#"
//     //           data-bs-toggle="modal"
//     //           data-bs-target="#delete"
//     //           onClick={()=>setDeleteId(item.id)}
//     //         >
//     //           <i className="fa fa-trash m-r-5" /> Delete
//     //         </Link>
//     //       </div>
//     //     </div>
//     //   ),
//     //   sorter: true,
//     // },
//   ];

//   // const columns = [
//   //   {
//   //     title: "Name",
//   //     dataIndex: "userName",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         <Link to="/profile" className="avatar">
//   //           <img alt="" src={record.selfieUrl} />
//   //         </Link>
//   //         <Link to="/profile">{text}</Link>
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Activity",
//   //     dataIndex: "name",
//   //   },
//   //   {
//   //     title: "Branch Name",
//   //     dataIndex: "branchName",
//   //   },
//   //   {
//   //     title: "Last Activity",
//   //     dataIndex: "",
//   //     render: (text, record) => (
//   //       <span className="table-avatar">
//   //         {moment(record.activityDate).format("MMMM Do YYYY, h:mm:ss a")}
//   //       </span>
//   //     ),
//   //   },
//   //   {
//   //     title: "Location",
//   //     dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
//   //     render: (text, record) => (
//   //       <a
//   //         href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
//   //         target="_blank"
//   //         rel="noopener noreferrer"
//   //       >
//   //         <i class="fa-solid fa-location-dot"></i>
//   //       </a>
//   //     )},
//   //   {
//   //     title: "View",
//   //     dataIndex: "actions",
//   //     render: (text, record) => (
//   //       <Button className="btn-property">
//   //           <i className="fa-solid fa-eye"></i>
//   //           </Button>
//   //     ),
//   //   },
//   // ]

//   return (
//     <>
//       <div className="page-wrapper">
//         <div className="content container-fluid">
//           {/* Page Header */}
//           <div className="page-header">
//             <div className="row align-items-center">
//               <div className="col-md-4">
//                 <h3 className="page-title">Desk Work</h3>
//                 <ul className="breadcrumb">
//                   <li className="breadcrumb-item">
//                     <Link to="/dashboard">Dashboard</Link>
//                   </li>
//                   <li className="breadcrumb-item active">Desk Work</li>
//                 </ul>
//               </div>
//               <div className="col-md-8 float-end ms-auto">
//                 <div className="d-flex title-head">
//                   <div className="view-icons">
//                     <div className="form-sort">
//                       <Link to="#" className="list-view btn btn-link">
//                         <i className="las la-file-export" />
//                         Export
//                       </Link>
//                     </div>
//                   </div>
//                   <Breadcrumbs
//                     modal="#add_client"
//                     name="Add Desk Work CLients"
//                     Linkname="/clients"
//                     Linkname1="/clients-list"
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* <Breadcrumbs
//             maintitle="Desk Work"
//             title="Dashboard"
//             subtitle="Desk Work"
//             modal="#add_client"
//             name="Add Desk Work CLients"
//             Linkname="/clients"
//             Linkname1="/clients-list"
//           /> */}
//           {/* /Page Header */}
//           <DeskFilter />
//           <div className="row">
//             <div className="col-md-12">
//               <div className="table-responsive">
//                 <SearchBox />
//                 <Table
//                   className="table-striped"
//                   style={{ overflowX: "auto" }}
//                   columns={columns}
//                   dataSource={allData}
//                   rowKey={(record) => record.id}
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//       <DeskModal DeskDataFetchFunc={allDeskData} selectedItem={selectedId} />
//       <DeskWorkDeleteModal Name="Delete Client" DeskWorkDeleteFunc={DeskWorkDeleteFunction}  />
//     </>
//   );
// };

// export default DeskList;

// Modal

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Table } from "antd";
import {
  Avatar_06,
  Avatar_07,
  Avatar_14,
  Avatar_18,
  Avatar_19,
  Avatar_22,
  Avatar_26,
  Avatar_29,
} from "../../../Routes/ImagePath";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import { ClientModelPopup } from "../../../components/modelpopup/ClientModelPopup";
import SearchBox from "../../../components/SearchBox";
import Breadcrumbs from "../../../components/Breadcrumbs";
import ClientsFilter from "../../../components/ClientsFilter";
import { DeskModal } from "./DeskModal";
import DeskFilter from "./DeskFilter";
import { Api_Url } from "../../../config/config";
import axios from "axios";
import { render } from "@testing-library/react";
import DeskWorkDeleteModal from "../../../components/modelpopup/DeskWorkDeleteModal";
import moment from "moment";

const DeskList = () => {
  const [allData, setAllData] = useState([]);

  const allDeskData = async () => {
    try {
      const id = JSON.parse(sessionStorage.getItem("user"))?.id;
      const response = await axios.get(
        `${Api_Url}api/v1/DeskWork?UserId=${id}&PageNumber=1&PageSize=10`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );
      console.log("response", response.data);
      setAllData(response?.data?.data);
    } catch (error) {
      return error;
    }
  };

  useEffect(() => {
    allDeskData();
  }, []);

  const [deleteId, setDeleteId] = useState(null);
  const DeskWorkDeleteFunction = async () => {
    try {
      const response = await axios.delete(
        `${Api_Url}api/v1/DeskWork/${deleteId}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      allDeskData();
    } catch (error) {
      return error.message;
    }
  };

  const [selectedId, setSelectedId] = useState(null);

  // console.log("object",selectedId)

  // console.log("object",allData)
  const columns = [
    // {
    //   title: "Name",
    //   dataIndex: "Name",
    //   render: (text, record) => (
    //     <span className="table-avatar">
    //       <Link to="/profile" className="avatar">
    //         <img alt="" src={record.Image} />
    //       </Link>
    //       <Link to="/profile">{text}</Link>
    //     </span>
    //   ),
    //   sorter: (a, b) => a.Name.length - b.Name.length,
    // },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Application No.",
      dataIndex: "applicationNo",
    },
    {
      title: "Loan Number",
      dataIndex: "loanNumber",
    },
    {
      title: "Remark",
      dataIndex: "remark",
    },
    {
      title: "Last Activity",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Location",
      dataIndex: "", // No dataIndex since this column doesn't directly map to a data field
      render: (text, record) => (
        <a
          href={`https://www.google.com/maps?q=${text.latitude},${text.longitude}`}
          target="_blank"
          rel="noopener noreferrer"
        >
          <i class="fa-solid fa-location-dot"></i>
        </a>
      ),
    },
  ];

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Page Header */}

          <div className="row">
            <div className="col-12 d-flex align-items-center justify-content-between">
              <h3 className="mb-0">Desk Work</h3>
              <div>
                <button className="btn border me-3">
                  <Link to="#" className="list-view btn btn-link">
                    <i className="las la-file-export" />
                    Export
                  </Link>
                </button>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={handleOpenModal}
                >
                  Add Desk Work
                </button>
                {isModalOpen && (
                  <DeskModal
                    onClose={handleCloseModal}
                    DeskDataFetchFunc={allDeskData}
                    selectedItem={selectedId}
                  />
                )}
              </div>
            </div>
          </div>

          {/* <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Desk Work</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Desk Work</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                    <div className="form-sort">
                      <Link to="#" className="list-view btn btn-link">
                        <i className="las la-file-export" />
                        Export
                      </Link>
                    </div>
                  </div>
                  <Breadcrumbs
                    modal="#add_client"
                    name="Add Desk Work CLients"
                    Linkname="/clients"
                    Linkname1="/clients-list"
                  />
                </div>
              </div>
            </div>
          </div> */}
          {/* <DeskFilter /> */}
          <div className="row mt-4">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={columns}
                  dataSource={allData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <DeskModal DeskDataFetchFunc={allDeskData} selectedItem={selectedId} /> */}
      <DeskWorkDeleteModal
        Name="Delete Client"
        DeskWorkDeleteFunc={DeskWorkDeleteFunction}
      />
    </>
  );
};

export default DeskList;
